/** Auth token — user JWT from auth store. */
export function getDevAgentSseToken(): string {
  const { useAuthStoreV1 } = require("@/stores/authStore_v1");
  return useAuthStoreV1.getState().token || "";
}

/** LangGraph node → user-friendly label. Unlisted nodes are hidden. */
export const STEP_LABELS: Record<string, string> = {
  classify: "Analyzing your request...",
  discover_impact: "Checking dependencies...",
  plan_task: "Planning the approach...",
  supervisor_dispatch: "Working on it...",
  compose_prompt: "Preparing...",
  prefetch_context: "Scanning your org...",
  call_llm: "Working on your answer...",
  execute_tools: "Fetching data from Salesforce...",
  save_result: "Finalizing...",
  compile_check: "Verifying code...",
  run_tests: "Running tests...",
  validate: "Validating...",
  self_refine: "Polishing the result...",
  check_approval: "Checking approval",
};

/** Normalize event type — UPPER → lower, TEXT_MESSAGE_CONTENT → text_delta */
const NORM: Record<string, string> = {
  TEXT_MESSAGE_CONTENT: "text_delta",
  RUN_START: "run_start",
  RUN_END: "run_end",
  TOOL_CALL_START: "tool_call_start",
  TOOL_CALL_END: "tool_call_end",
  ERROR: "error",
  TASK_PLAN: "task_plan",
  PLAN_GENERATED: "plan_generated",
  CODE_CHANGE: "code_change",
  APPROVAL_REQUIRED: "approval_required",
  VALIDATION_RESULT: "validation_result",
  SUB_AGENT_START: "sub_agent_start",
  SUB_AGENT_END: "sub_agent_end",
  PLAN_STEP_START: "plan_step_start",
  PLAN_STEP_COMPLETE: "plan_step_complete",
  PLAN_STEP_FAILED: "plan_step_failed",
  CLARIFICATION_REQUEST: "clarification_request",
  TRANSPARENCY_REPORT: "transparency_report",
  GOVERNOR_REPORT: "governor_report",
  SUMMARY: "summary",
  ARTIFACT_LOADED: "artifact_loaded",
  SF_TOKEN_UNAUTHORIZED: "sf_token_unauthorized",
};

export function normalizeSseEventType(raw: string): string {
  return NORM[raw] || raw.toLowerCase();
}

/** Metadata types eligible for auto-open in editor */
export const CODE_TYPES = new Set([
  "ApexClass",
  "ApexTrigger",
  "ApexPage",
  "ApexComponent",
  "LightningComponentBundle",
  "AuraDefinitionBundle",
]);
